export const WEB_TEXT = 'web作品';
export const ELECT_TEXT = '電子工作品';
export const INQUIRY_TEXT = 'Q&A集';
export const MEDIA_TEXT = 'メディア作品';
export const GAME_TEXT = 'ゲーム作品';
export const HOME_TEXT = 'Home';
export const MENU_LIST = '作品一覧';
export const SEARCH = '検索';
export const ACTIVITY_TEXT = '活動内容';
export const RIGHT = 'right';
export const ADJACENT_CARD = 'adjacent';

export const TITLE = 'title';
export const PHILOSOPHY = '1';
export const ACTIVITIES = '2';

export const HORIZONTAL = 'horizontal';
export const VERTICAL = 'VERTICAL';
export const GAME = 'game';
export const MEDIA = 'media';
export const WEB = 'web';
export const ELECT = 'elect';
export const INQUIRY = 'inquiry';
export const ERROR = 'error';
export const HOME = '';
export const ACTIVITY = 'activity';

export const VISION = 'vision';
export const MISSION = 'mission';
export const VALUE = 'value';
export const NOT_FOUND = 'お探しのページが見つかりませんでした。';

export const FOOTER_CLASS_NAME = 'footerList';

export const CLUB_INFO = '〒191-8506 東京都日野市程久保2-1-1 Ponte棟325号室\nGmail:meisei.denkibu@gmail.com';

export const GAME_LIST = 'ゲーム作品一覧';
export const DESCRIBE = 'describe';
export const PLAY = 'Go To Play';
export const GAME_CAUTION = '※外部サイトへ遷移します。';

export const QUESTION_TITLE = 'よくある質問集(Q&A)';